<template>
    <div id="mobileInfoBar" :class="[$store.getters.getOrientation]">
        <div id="mobileOdometerAndZipBar">
            <odometer-wrapper/>
            <zip-filter/>
        </div>
        <sort-bar/>
        <!--<div id="contactUsBlueButtonBar" @click="openScheduling">
            <img id="letUsFindItBullsEyeIcon" src="@/assets/LetUsFindItBullsEyeDartIcon.png"/>
            <span> 
                &nbsp;LET US FIND IT FOR YOU
            </span>
        </div>-->
    </div>
</template>

<script>
    import OdometerWrapper from './OdometerWrapper.vue';
    import ZipFilter from './ZipFilter.vue';
    import SortBar from '../components/SortByBar';

    export default {
        components: {
            'odometer-wrapper': OdometerWrapper,
            'zip-filter': ZipFilter,
            'sort-bar': SortBar
        },
        /*methods: {
            openScheduling() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('appointment', {'event_category': 'contactUs','event_label': eventLabel});
                this.$store.dispatch('openAppInSeperateWindow', 'https://www.online.cars/schedule/');
            }
        }*/
    }
</script>

<style>
    #mobileInfoBar {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        /*position: fixed;
        top: calc(12 * var(--vh));
        left: 0;*/
        width: calc(100 * var(--vw));
        height: calc(18 * var(--vh));
        background-color: #2b2a2b;
        color: white;
    }

    .tabletstyle .landscape#mobileInfoBar {
        align-items: center;
    }

    #mobileOdometerAndZipBar {
        display: flex;
        width: calc(100 * var(--vw));
        height: calc(8 * var(--vh));
        align-items: center;
        justify-content: space-evenly;
    }

    .tabletstyle .landscape #mobileOdometerAndZipBar {
        width: calc(94 * var(--vw));
        justify-content: space-between;
    }

    #contactUsBlueButtonBar {
        width: calc(100 * var(--vw));
        height: calc(5 * var(--vh));
        background-color: var(--mccluskeyBlue);/*#0077C0;*//*#0079B6;*/
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
</style>